<p class="border-surface-300 bg-card-background font-default rounded-lg border-4 p-4 text-6xl tracking-wider select-none 2xl:text-8xl">
  @for (segment of styledSegments(); track $index) {
    @for (text of segment; track $index) {
      <span
        class="inline-block"
        [style.opacity]="hideText() ? 0 : text.opacity"
        [style.scale]="text.opacity === 1 ? 1 : 0.85"
        [style.transition]="'opacity ' + text.duration + 'ms ease-out, scale ' + text.duration + 'ms ease-out'"
        >{{ text.text }}</span
      >
    }
    @if (!isCompressed() && $index < segments().length - 1) {
      <div class="inline-block w-[0.75ch]" animate.enter="segment-appear" animate.leave="segment-hide">
        <span class="text-surface-500 block" [style.opacity]="hideText() ? 0 : 1" [style.transition]="'opacity 200ms ease-out'">·</span>
      </div>
    }
  }
</p>
